import { z } from "zod";

// ============================================================================
// USER ROLE SCHEMAS
// ============================================================================

export const UserRoleSchema = z.enum(["user", "admin", "super-admin"]);

export const UserRoleResponseSchema = z.object({
  isAdmin: z.boolean(),
  role: UserRoleSchema.nullable().transform((v) => v ?? "user"),
});

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type UserRole = z.infer<typeof UserRoleSchema>;
export type UserRoleResponse = z.infer<typeof UserRoleResponseSchema>;
